import { Component, input } from '@angular/core'
import { featureFlag } from '@ftr/ui-feature-flags'
import { LogoSize, LogoTheme } from '../../types'
import { FooterHelpLinksComponent } from '../footer-help-links'
import { FtrLogoComponent } from '../ftr-logo'

@Component({
  selector: 'ftr-footer-logged-out',
  templateUrl: './footer-logged-out.component.html',
  styleUrls: ['./footer-logged-out.component.css'],
  imports: [FtrLogoComponent, FooterHelpLinksComponent],
})
export class FooterLoggedOutComponent {
  theme = input<'white' | 'grey'>('white')

  readonly logoThemes = LogoTheme
  readonly logoSizes = LogoSize

  isPublicNavigationEnabled = featureFlag('public-navigation')
}
